<template>
  <div class="d-flex flex-column fill-width pa-2">
    <div class="h-row-top">
      <div class="pa-2" style="width: 450px">
        <Sidebar :client="value" @select="select" />
      </div>

      <div class="v-row" style="width: calc(100% - 450px)">
        <div class="px-10">
          <v-text-field label="Filtrar..." v-model="keywords" clearable />
        </div>

        <div class="h-row-top">
          <div class="pa-2 flex-grow-1" style="width: calc(100% - 450px) / 2">
            <MailboxContents :item="item1" :keywords="keywords" />
          </div>

          <div class="pa-2 flex-grow-1" style="width: calc(100% - 450px) / 2">
            <MailboxContents :item="item2" :keywords="keywords" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  tabTitle: 'Comparação',
  tabGroup: 'Módulo',
  components: {
    Sidebar: require('./Sidebar').default,
    MailboxContents: require('./MailboxContents').default
  },
  props: {
    value: { required: true }
  },
  data() {
    return {
      isLoading: false,
      item1: null,
      item2: null,
      keywords: null
    }
  },
  // watch: { client() { this.reload() } },
  // mounted() { this.reload() },
  methods: {
    reload() {
      // this.$loading(() => this.fetchData())
    },
    select({ panel, item }) {
      if (panel == 1) {
        this.item1 = item
      } else {
        this.item2 = item
      }
    }
  }
}
</script>

<style></style>
